import React from 'react';
import { bool, func } from 'prop-types';

import Button from '@material-ui/core/Button';

import defaultClasses from './AddSensorPromptCell.module.css';

const AddSensorPromptCell = ({ disabled, onNewSensor }) => {
    function handleAddNewSensor() {
        onNewSensor();
    }

    return (
        <aside className={defaultClasses.root}>
            <div aria-hidden>
                <img
                    alt=""
                    height="99"
                    src="/assets/images/rulesAddSensorPrompt.svg"
                    width="100"
                />
                <div className={defaultClasses.caption}>
                    It's hot in here, add some sensors to get this fixed:
                </div>
            </div>
            <Button
                classes={{
                    root:  defaultClasses.button,
                    label: defaultClasses.buttonLabel
                }}
                color="primary"
                disabled={disabled}
                onClick={handleAddNewSensor}
                type="button"
                variant="contained"
            >
                Add Sensor Filter
            </Button>
        </aside>
    );
};

AddSensorPromptCell.defaultProps = {
    disabled:    false,
    onNewSensor: () => {}
};

AddSensorPromptCell.propTypes = {
    disabled:    bool,
    onNewSensor: func
};

export default AddSensorPromptCell;
